export default "dist/images/block-blog-posts-vertical-card2.37ccf64.png";